
export default function HeroSection() {
  return (
    <section className="relative bg-gradient-to-br from-blue-600 to-purple-600 text-white py-20">
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Modern%20content%20creator%20workspace%20with%20laptop%2C%20notebooks%2C%20coffee%2C%20creative%20writing%20setup%2C%20blog%20content%20creation%20environment%2C%20professional%20blogging%20workspace%2C%20inspiring%20atmosphere&width=1920&height=800&seq=blog-hero&orientation=landscape')`
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-blue-900/90 to-purple-900/90"></div>
      </div>
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-6">
          Funnel Insights & Tips
        </h1>
        <p className="text-xl sm:text-2xl text-blue-100 mb-8 max-w-3xl mx-auto leading-relaxed">
          Learn the latest strategies, tips, and case studies to optimize your sales funnels and boost conversions.
        </p>
        <div className="flex flex-wrap justify-center gap-8">
          <div className="flex items-center">
            <i className="ri-article-line text-3xl text-green-400 mr-3"></i>
            <span className="text-lg">Weekly Articles</span>
          </div>
          <div className="flex items-center">
            <i className="ri-bar-chart-line text-3xl text-yellow-400 mr-3"></i>
            <span className="text-lg">Case Studies</span>
          </div>
          <div className="flex items-center">
            <i className="ri-lightbulb-line text-3xl text-purple-300 mr-3"></i>
            <span className="text-lg">Expert Tips</span>
          </div>
        </div>
      </div>
    </section>
  );
}